import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../../boot/index.js';

export const getBilling = createAsyncThunk('billing/getlist-billing', async (data)=> {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-billing`);
        console.log({response});
        return response;
        
    }
);                      